import { Component } from '@angular/core';

@Component({
  selector: 'yacare-spinner',
  templateUrl: './yacare-spinner.component.html',
  styleUrls: ['./yacare-spinner.component.scss']
})
export class YacareSpinnerComponent {}
